/**
 *  localStorage
 */

// 操作记录
const operationRecordKey = "operationRecord";
export const setOperationRecord = (record) => {
  if (record && typeof record === "object") {
    localStorage.setItem(operationRecordKey, JSON.stringify(record));
  }
};
export const removeOperationRecord = () => {
  localStorage.removeItem(operationRecordKey);
};

export const getOperationRecord = () => {
  const recordStr = localStorage.getItem(operationRecordKey);
  if (recordStr) {
    return JSON.parse(recordStr);
  }
  return null;
};
